export default __webpack_public_path__ + "static/media/rocketman.40042ce3.png";